import { ContentProvider } from "./Core/Content/Provider";
import { DashboardComponent } from "./Features/Dashboard/Component";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { RouteConstants } from "./Core/Constants/RouteConstants";
import { AboutComponent } from "./Features/About/Component";
import { BookingComponent } from "./Features/Booking/Component";
import { ContactComponent } from "./Features/Contact/Component";
import { HomeComponent } from "./Features/Home/Component";
import { PackagesComponent } from "./Features/Packages/Component";
import { PaymentsComponent } from "./Features/Payments/Component";
import { PortfolioComponent } from "./Features/Portfolio/Component";
import { ServicesComponent } from "./Features/Services/Component";
import { ThisIsMeComponent } from "./Features/ThisIsMe/Component";
import { LayoutComponent } from "./Shared/Layout/Component";
import { EmptyStatePiece } from "./Shared/UI/EmptyStatePiece";

const App = () => (
  <ContentProvider><BrowserRouter>
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          background: "rgba(0, 20, 39, 0.96)",
          color: "#ffffff",
          border: "1px solid rgba(157, 122, 27, 0.24)",
        },
      }}
    />
    <LayoutComponent>
      <Routes>
        <Route path="/this-is-me" element={<ThisIsMeComponent />} />
        <Route path="/dashboard" element={<DashboardComponent />} />
        <Route path={RouteConstants.home} element={<HomeComponent />} />
        <Route path={RouteConstants.services} element={<ServicesComponent />} />
        <Route path={RouteConstants.packages} element={<PackagesComponent />} />
        <Route path={RouteConstants.portfolio} element={<PortfolioComponent />} />
        <Route path={RouteConstants.about} element={<AboutComponent />} />
        <Route path={RouteConstants.contact} element={<ContactComponent />} />
        <Route path={RouteConstants.booking} element={<BookingComponent />} />
        <Route
          path={RouteConstants.paymentSuccess}
          element={<PaymentsComponent mode="success" />}
        />
        <Route
          path={RouteConstants.paymentCancel}
          element={<PaymentsComponent mode="cancel" />}
        />
        <Route
          path="*"
          element={
            <section className="section-shell">
              <EmptyStatePiece
                title="Scene missing"
                message="That route is not part of the CMJ Cinema public site."
                actionLabel="Return home"
                actionTo={RouteConstants.home}
              />
            </section>
          }
        />
      </Routes>
    </LayoutComponent>
  </BrowserRouter></ContentProvider>
);

export default App;
